<template>
<div :class="canEdit ? 'admin' : 'user'">
    <div class="page-header">
        <h3 class="flex-grow-1" v-html="title ? title : $t('Externa terminalkartor')"></h3>

        <div class="btn-group mr-2">
            <button @click="saveExternal()" class="btn btn-success"><fa :icon="['fas','save']" /> Spara</button>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-header">
          <h5 class="m-0">Filtrera</h5>
        </div>
        <div class="card-body">
            <div class="input-group mr-2 z-50">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="basic-addon1">
                    <fa :icon="['far','filter']" />
                    </span>
                </div>
                <input v-model="filter.text" type="text" class="form-control" placeholder="Filtrera på namn" @keyup="doFilter">
            </div>
        </div>
    </div>

    <div class="card pt-1 card-top">
        <table
            class="table"
        >
            <tr class="h-">
                <th class="table-head text-center position-relative">
                    <div>Visa på webb</div>
                    <input class="all-checkbox" type="checkbox" :checked="allChecked" @click="toggleChecked($event)" >
                </th>
                <th class="table-head">Namn</th>
                <th class="table-head">Stop area</th>
                <th class="table-head">Site</th>
                <th class="table-head">Filnamn</th>
            </tr>
            <tr v-if="ready == true" v-for="(item, index) in external" :key="index + 'row'">
                <td class="checkbox-td">
                    <label class="checkbox-label" :for="'check' + index">
                        <input type="checkbox" :id="'check' + index" v-model="item.active" :value="item" @click.stop="" > 
                    </label>
                </td>
                <td>
                    <span :title="item.name">
                        <input class="form-control" v-model="item.name">
                    </span>
                </td>
                <td>
                    <span :title="item.stop_area">
                        <input class="form-control" v-model="item.stop_area">
                    </span>
                </td>
                <td>
                    <span :title="item.site">
                        <input class="form-control" v-model="item.site">
                    </span>
                </td>
                <td class="td-content">
                    <span class="" :title="item.original_name">
                        <span> {{ item.original_name }} </span>
                    </span>
                </td> 
            </tr>
            <tr v-if="ready == false">
                <td colspan="5" class="text-center p-2">
                    <fa :icon="['fas','circle-notch']" spin v-if="loading" /> {{ loading ? 'Läser in artiklar...' : 'Inga artiklar' }}
                </td>
            </tr> 
        </table>
        
    </div>
</div>
</template>

<script>
    import axios from "axios";
    import store from "~/store";
    import swal from "sweetalert2";

    import { TableComponent, TableColumn } from "~/components/table";


export default {
    middleware: ["auth"],
    metaInfo() {
        return { title: this.$t("External Maps")}
    },
    components: {
        TableComponent,
        TableColumn,
    },

    data() {
        return {
            checkedRows: [],
            title: '',
            loading: true,
            terminal: [],
            external: [],
            external_base: [],
            external_maps: [],
            pageination: '',
            ready: false,
            filter: {
                text: ''
            },
            sort: {
                fieldName: 'updated_at',
                order: 'asc'
            },
        }
    },

    created() {
        this.fetchTerminalMaps();
        this.fetchExternalMaps();
        this.filterList();
    },

    computed: {
        canEdit() {
            return store.getters["auth/user"]
                ? store.getters["auth/user"].role >= 3
            : -1;
        },
        allChecked() {
            if(this.external.filter(ex => ex.active != 1).length > 0) {
                return false;
            } else {
                return true;
            }
        },
        query() {
            return this.$route.query ? this.$route.query : false;
        },
    },

    methods: {
        doFilter() { 
            var filteredArray =  this.external_base.filter(external => external.name.indexOf(this.filter.text) > -1)
            console.log(filteredArray);
            this.external = filteredArray;
        },
        async fetchTerminalMaps() {
            this.loading = true;
            this.terminal = [];
            const response = await axios.get("/api/printable/project/1");

            this.terminal = response.data;
        },
        async fetchExternalMaps() {
            this.external = [];
            const response = await axios.get("/api/external/getAll");
            this.external = response.data;
            this.external_base = response.data;            
        },
        async saveExternal() {
            let url = '/api/external/save';

            let params = {
                external: this.external,
            }

            const response = await axios.post(url, params);

            location.reload();
        },
        filterList() {
            if(this.terminal.length == 0) {
                setTimeout(() => {
                    this.filterList();
                }, 500);
                
            } else {
                this.$nextTick(() => {
                    this.terminal.forEach(element => {

                        // if terminal has new maps that doest not exist in external add them
                        if(this.external.filter(ex => ex.printable_id == element.id).length == 0) {
                            let obj = {
                                created_at: null,
                                name: element.name,
                                printable_id: element.id,
                                active: null,
                                site: null,
                                stop_area: null,
                                original_name: element.name,
                                updated_at: null,
                            }
                            this.external.push(obj)
                        }
                    });

                    this.external.sort((a, b) => (a.original_name > b.original_name) ? 1 : -1)
                });

                this.ready = true;
            }
        },
        toggleChecked(e){
           if(!e.target.checked){
               this.external.forEach(item => {
                   item.active = false;
               });

           } else {
               this.external.forEach(item => {
                   item.active = true;
               });
           }
        },   
    }
}
</script>

<style lang="scss" scoped>
    .checkbox-td {
        padding: 0 !important;
        max-width: 75px;
        width: 75px;
        padding-bottom: 0;
        text-align: center;
    }

    .checkbox-label {
        margin-top: 0.35rem;
        padding: 1.2rem 0.3rem;
        height: 100%;
        width: 100%;
    }

    .td-content {
        span {
            display: block;
            padding-top: 5px;
        }
    }

    .z-index {
        z-index: 50;
    }

    .all-checkbox {
        position: absolute;
        bottom: 0.5rem;
        left: 0;
        right: 0;
        margin: 0 auto;
    }

    .card-top {
        background-color: #f8f9fa;
        border-top: none !important;
    }

    .table th {
        padding: 25px 10px !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/external/index.vue